import Icon from '../components/Icon.vue'

Icon.register({
  headset: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M192 208v112c0 17.7-14.3 32-32 32h-16c-35.3 0-64-28.7-64-64v-48c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32zM368 352h-16c-17.7 0-32-14.3-32-32v-112c0-17.7 14.3-32 32-32h16c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64zM256 0c142.8 0 251.4 118.8 256 256v165.7c0 49.9-40.4 90.3-90.3 90.3h-181.7c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c26.5 0 48 21.5 48 48h101.7c23.4 0 42.3-18.9 42.3-42.3 0 0 0-163.3-0.1-165.7h0.1c0-114.7-93.3-208-208-208s-208 93.3-208 208v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c4.6-137.2 113.2-256 256-256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/headset.js
// module id = 1451
// module chunks = 0